import { render, staticRenderFns } from "./ProductComparisonTableColumnHeader.vue?vue&type=template&id=886cd88e"
import script from "./ProductComparisonTableColumnHeader.vue?vue&type=script&lang=js"
export * from "./ProductComparisonTableColumnHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports